import jwt_decode from "jwt-decode";

// TODO: add type
export const getCurrentUser = (): {email: string} => {
    const token = localStorage.getItem("idToken");
    return token && jwt_decode(token);
};
